import { combineReducers } from "redux";
import * as auth from "../views/pages/login/_redux/authRedux";
import { sideBarSlice } from "src/containers/_redux/sideBarSlice";
import { quoteSlice } from "src/views/quoteStatus/_redux/quoteSlice";
import { orderSlice } from "src/views/ordered-items/_redux/orderSlice";
import { publicSlice } from "src/views/pages/_redux/publicSlice";
import { chatSlice } from "src/views/chatManagement/_redux/chatSlice";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  sideBar: sideBarSlice.reducer,
  quote: quoteSlice.reducer,
  orders: orderSlice.reducer,
  public: publicSlice.reducer,
  chat: chatSlice.reducer,
});
